import React from 'react';
import PropTypes from 'prop-types';

import { NumberInputSelect } from '../../components';
const maxDropdownItems = 10;

class CartItem extends React.Component {
  constructor(props) {
    super(props);
    this.onQuantityChange = this.onQuantityChange.bind(this);
  }

  onQuantityChange(qty) {
    let quantity = Number(qty);
    const item = this.props.item;
    if (quantity > 0) {
      const minimumQuantity = Math.max(item.MinQuantity, 1);
      const multiple = item.PackageMultiple > 0 ? item.PackageMultiple : 1;
      const currentQuantity = item.Quantity;
      const mod = (quantity - minimumQuantity) % multiple;
      if (mod > 0) {
          if (quantity > currentQuantity) {
              quantity = quantity + (multiple - mod);
          } else {
              quantity = quantity - mod;
          }
      }
      this.props.onQuantityChange(item.Id, quantity);
    } else {
      this.props.onDelete(item.Id, item.Quantity);
    }
  }

  render() {
    const item = this.props.item;
   
    return (
        <div className={`media cart-item mb-4`}>
            <img alt={item.Name} src={item.ImageUrl} style={{
                "maxWidth": "64px",
                "border": item.IsRestricted ? "1px red solid" : "none"}}
            />
            

            <div className="media-body col-sm-11">
                <div className="media-header checkout-cart-item-name">
                    <h5>{item.Name}</h5>
                    {item.IsRestricted &&
                        <span className="badge badge-danger">
                            {this.props.translationUtility.translateResourceString("/Checkout/RestrictedItemBadge")}
                        </span>
                    }
                </div>
              <span className="checkout-cart-item-sku" style={{ marginRight: 10 }}>
                Sku: {item.SKU}
              </span>
              <NumberInputSelect
                maxDropdownItems={maxDropdownItems}
                componentClassName={"checkout-cart-item-quantity"}
                quantity={this.props.item.Quantity}
                onChange={this.onQuantityChange}
                onDelete={(e) => {
                  typeof e !== 'undefined' && typeof e.preventDefault !== 'undefined' && e.preventDefault();
                  this.props.onDelete(item.Id, this.props.item.Quantity);
                }}
                minQuantity={this.props.item.MinQuantity}
                multipleOf={this.props.item.PackageMultiple}
              />
            </div>
      </div>
    );
  }
}

CartItem.propTypes = {
  item: PropTypes.shape({
    MinQuantity: PropTypes.number,
    Name: PropTypes.string.isRequired,
    ImageUrl: PropTypes.string.isRequired,
    SKU: PropTypes.string.isRequired,
    Quantity: PropTypes.number.isRequired,
    IsRestricted: PropTypes.bool
  }).isRequired,
  onDelete: PropTypes.func,
  onQuantityChange: PropTypes.func.isRequired,
  translationUtility: PropTypes.shape({
    translateResourceString: PropTypes.func.isRequired
  }).isRequired
}

export default CartItem;


// WEBPACK FOOTER //
// ./src/Components/checkout/Features/Cart/CartItem.jsx